<template>
<div>
    <b-modal id="invoiceUpdateItemFormModal" centered size="lg" no-close-on-backdrop ref="invoiceUpdateItemFormModal" :title=" $t('invoiceUpdateItem.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-col class="col-lg-12">
                <label for="invoice-detail-ledes-input">{{ $t('invoiceUpdateItem.ledes_detail') }}</label>
                <b-form-select size="sm" v-model="ledesDetailSelect" value-field="id" text-field="name" :options="ledesDetailOption"> </b-form-select>
            </b-col>
            <b-col class="col-lg-12">
                <label for="invoice-add-item-name-input">{{ $t('invoiceUpdateItem.name') }}</label>
                <validation-provider #default="{ errors }" :name=" $t('invoiceUpdateItem.name')" rules="required">
                    <b-form-textarea id="invoice-add-item-name-input" size="sm" rows="3" maxlength="750" :state="errors.length > 0 ? false:null" v-model="name" />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-col>

        </validation-observer>
    </b-modal>

</div>
</template>

<script>
export default {
    props: {
        showInvoiceInfo: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            invoiceId: 0,
            name: '',
            ledesDetailOption: [],
            ledesDetailSelect: 0,
        }
    },
    methods: {
        showInfo(id, invoiceId) {
            this.id = id
            this.invoiceId = invoiceId
            this.$refs['invoiceUpdateItemFormModal'].show()

            const data = {
                id: this.id
            }
            const controller = {
                name: 'InvoiceDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.name = response.data.invoiceDetail.name
                    this.ledesDetailOption = response.data.ledesDetailList;
                    this.ledesDetailOption.splice(0, 0, this.$nullSelected())
                    if (response.data.invoiceDetail.ledesDetailId > 0) {
                        this.ledesDetailSelect = response.data.invoiceDetail.ledesDetailId
                    } else {
                        this.ledesDetailSelect = 0;
                    }
                } else {
                    this.$bvModal.hide('invoiceUpdateItemFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })

        },
        addOrUpdate() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    const data = {
                        id: this.id,
                        name: this.name,
                        invoiceId: this.invoiceId,
                        ledesDetailId: this.ledesDetailSelect
                    }

                    const controller = {
                        name: 'InvoiceDetail',
                        actionName: 'updateInvoiceDetail'
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }

                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('invoiceUpdateItemFormModal')
                            this.showInvoiceInfo(this.invoiceId)

                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style>
.tab-content>.active {
    display: block;
    width: 75em;
}
</style>
